<script setup>
import { reactive } from 'vue'
import ManGroup from '../ManGroup.vue'
import { useMetaStore } from '@/stores'
import _ from 'lodash-es'
import { get, post, validators, ymd } from '@/common/util'
import ConfirmCard from '@/components/ConfirmCard.vue'
import Logs from '../config/Logs.vue'
import { useRouter,useRoute } from 'vue-router'
import { onBeforeRouteUpdate } from 'vue-router'
const metaStore=useMetaStore(),router=useRouter(),route=useRoute()
  ,meta=reactive({tartbl:'Externalapi',groups:[],searchgroups:[],featuretypes:['WMS','WFS','WCS','WPS','TMS'],data:{rows:[]},search:{page:1,size:20,sortcol:'mdt',isasc:false,where:{}},tblheight:400,searchgroupid:'all'
  ,heads:[{tk:'uniquenumber',col:'id'},{tk:'enabledisable',col:'enabled'},{tk:'title',col:'ttl'},{tk:'groupname',col:'groupid'},{tk:'integrations',col:'organization'},{tk:'registrationmodificationdate',col:'mdt'},{tk:'viewdetails'},{tk:'delete'}]})
,pop=async(type)=>{
  meta.poptype=null
  if(_.isEmpty(type)||type.toString().includes('Event'))return metaStore.pop({ison:false})
  metaStore.pop({ison:true,callback:()=>meta.poptype=type,onclose:()=>{
    if(type=='mangroup')initGroups()
  }})
},initGroups=async()=>{
  metaStore.blockLoading()
  const res=await get('rest/authed/member/groups/'+meta.tartbl)
  metaStore.blockLoading(false)
  meta.groups=res.data
  meta.groups.splice(0,0,{id:'defaultgroups',nm:metaStore.t('defaultgroups'),tartbl:meta.tartbl})
  meta.searchgroups=[...meta.groups]
  meta.searchgroups.splice(0,0,{id:'all',nm:metaStore.t('all'),tartbl:meta.tartbl})
},addGroup=async()=>{
  if(meta.selextapi.groupid=='defaultgroups')delete meta.selextapi.groupid
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/addgroup',{nm:meta.groupnm,tartbl:meta.tartbl})
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
  if(!res.isSuccess)return pop('addgroup')
  initGroups()
  pop()
  if(meta.selextapi)meta.selextapi.groupid=res.data.id
},mod=async()=>{
  metaStore.blockLoading()
  if(meta.selextapi&&meta.selextapi.groupid=='defaultgroups')meta.selextapi.groupid=null
  const res=await post('rest/authed/admin/data/'+(meta.poptype=='save'?'mod':'del')+'extapi',meta.poptype=='save'?meta.selextapi:{id:meta.delid})
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,meta.poptype=='save')
  meta.selextapi=null
  search()
},sort=col=>{
  if(!meta.data.rows.length)return
  if(meta.search.sortcol!=col)meta.search.sortcol=col
  else meta.search.isasc=!meta.search.isasc
  search()
},search=async()=>{
  initGroups()
  meta.search.where={}
  if(meta.searchgroupid=='defaultgroups')meta.search.where.groupid_eq_=null
  else meta.search.where.groupid_eq_=meta.searchgroupid
  if(meta.searchgroupid=='all')delete meta.search.where.groupid_eq_
  if(!_.isEmpty(meta.searchval)){
    meta.search.where.ttl_or_=meta.searchval
    meta.search.where.cont_or_=meta.searchval
    meta.search.where.apikey_or_=meta.searchval
    meta.search.where.organization_or_=meta.searchval
    meta.search.where.url_or_=meta.searchval
    meta.search.where.featuretype_or_=meta.searchval
  }
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/searchextapi',meta.search)
  metaStore.blockLoading(false)
  meta.data=res.data
  meta.data.rows.forEach(eapi =>{
    if(eapi.groupid===null)eapi.groupid='defaultgroups'
  })
  meta.tblheight=window.innerHeight-310
}
search()
onBeforeRouteUpdate((to, from) => {
  if(!to.hash||to.hash=='')meta.selextapi=null
})
</script>
<template>
  <div class="admextapi">
    <v-card v-if="!meta.selextapi">
      <v-card-title>
        <v-row>
          <v-col cols="3"><v-select hide-details variant="outlined" density="compact" :items="meta.searchgroups" item-title="nm" item-value="id" v-model="meta.searchgroupid"/></v-col>
          <v-col><v-text-field hide-details variant="outlined" density="compact" v-model="meta.searchval"/></v-col>
          <v-col cols="2"><v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')" @click="search"/></v-col>
          <v-col cols="1" class="ps-1 pe-1 me-2"><v-btn block :text="$t('managegroups')" @click="pop('mangroup')"/></v-col>
          <!-- <v-col cols="1" class="ps-1 pe-1 me-2"><v-btn :text="$t('download')"/></v-col> -->
          <v-col cols="1" class="ps-1 pe-1"><v-btn color="primary" :text="$t('newregistration')" @click="meta.selextapi={enabled:true,groupid:'defaultgroups',featuretype:'WFS'};router.push({hash: '#new'})"/></v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-table fixed-header :height="meta.tblheight">
          <thead>
            <tr>
              <th v-for="head in meta.heads" class="cursor-pointer" @click="sort(head.col)">{{ $t(head.tk) }}
                <v-icon v-if="meta.data.rows.length&&head.col==meta.search.sortcol" :icon="meta.search.isasc?'mdi-arrow-up':'mdi-arrow-down'"/>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!meta.data.rows.length">
              <td :colspan="meta.heads.length" class="text-center">{{ $t('noresultsfound')+' '+$t('pleaseconfirmyoursearchterm') }}</td>
            </tr>
            <tr v-for="row in meta.data.rows">
              <td v-for="head in meta.heads" class="text-center">
                <div v-if="head.col=='groupid'">{{ meta.groups.find(group=>group.id==row.groupid)?.nm }}</div>
                <div v-else-if="head.col=='mdt'">{{ ymd(row[head.col]) }}</div>
                <v-row v-else-if="head.col=='enabled'" justify="center">
                  <v-switch readonly hide-details color="primary" :model-value="row[head.col]"/>
                </v-row>
                <div v-else-if="head.col">{{ row[head.col] }}</div>
                <v-btn v-else :text="$t(head.tk)" :color="head.tk=='delete'?'error':''" @click="async()=>{
                  if(head.tk=='viewdetails'){
                    await initGroups()
                    router.push({hash: '#detail'})
                    meta.selextapi=row
                  }
                  if(head.tk=='delete'){
                    meta.delid=row.id
                    pop('del')
                  }
                }"/>
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
      <v-card-actions>
      <v-pagination class="ma-auto" v-if="meta.data.rows.length" :length="meta.data.totalPages" :total-visible="meta.data.pageCount" v-model="meta.search.page" @update:model-value="search"/>
      </v-card-actions>
    </v-card>
    <v-card flat v-else>
      <v-card-title>
        <v-row>
          <v-col>{{ $t('details') }}</v-col>
          <v-col v-if="meta.selextapi.id" class="text-right"><v-btn variant="outlined" density="compact" class="pb-1" :text="$t('viewlogs')" @click="pop('log')"/></v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-table>
          <tbody class="detail">
              <v-defaults-provider :defaults="{global:{variant:'outlined',density:'compact'}}">
                <tr v-if="meta.selextapi.id">
                  <th>{{ $t('uniquenumber') }}</th>
                  <td>{{ meta.selextapi.id }}</td>
                  <th>{{ $t('registrationmodificationdate') }}</th>
                  <td>{{ ymd(meta.selextapi.mdt) }}</td>
                </tr>
                <tr>
                  <th>{{ $t('enabled') }}</th>
                  <td colspan="3">
                    <v-switch color="primary" :label="$t('enabledisable')" v-model="meta.selextapi.enabled"/>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t('groupname') }}</th>
                  <td colspan="3">
                    <v-row>
                      <v-col><v-select v-model="meta.selextapi.groupid" :items="meta.groups" item-title="nm" item-value="id"/></v-col>
                      <v-col cols="1"><v-btn size="40" prepend-icon="mdi-plus" @click="pop('addgroup')"/></v-col>
                    </v-row>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t('title') }}*</th>
                  <td colspan="3">
                    <v-text-field v-model="meta.selextapi.ttl" :rules="[validators.required]"/>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t('contents') }}</th>
                  <td colspan="3">
                    <v-textarea v-model="meta.selextapi.cont"/>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t('integrations') }}</th>
                  <td colspan="3">
                    <v-text-field v-model="meta.selextapi.organization"/>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t('apikey') }}</th>
                  <td colspan="3">
                    <v-text-field v-model="meta.selextapi.apikey"/>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t('url') }}*</th>
                  <td colspan="3">
                    <v-textarea v-model="meta.selextapi.url" :rules="[validators.required]"/>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t('layertype') }}</th>
                  <td colspan="3">
                    <v-select :items="meta.featuretypes" v-model="meta.selextapi.featuretype"/>
                  </td>
                </tr>
              </v-defaults-provider>
            </tbody>
          </v-table>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col/>
          <v-col cols="2"><v-btn block variant="outlined" :text="$t('cancel')" @click="meta.selextapi=null"/></v-col>
          <v-col cols="2"><v-btn block variant="elevated" color="primary" :text="$t('confirm')" :disabled="['ttl','url'].map(key=>meta.selextapi[key]).some(_.isEmpty)" @click="pop('save')"/></v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
  <Teleport v-if="meta.poptype" to="#popbody">
    <ManGroup v-if="meta.poptype=='mangroup'" :tartbl="meta.tartbl"/>
    <v-card v-if="meta.poptype=='addgroup'" min-width="300" :title="$t('newgroups')">
      <v-card-text>
        <v-text-field variant="outlined" density="compact" :label="$t('newgroupname')" maxlength="50" :placeholder="$t('enteranameforyourgroupupto50characters')" :rules="[validators.required]" v-model="meta.groupnm"/>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col class="text-right">
            <v-btn variant="outlined" class="me-4" :text="$t('cancel')" @click="pop()"/>
            <v-btn variant="elevated" color="primary" :text="$t('confirm')" :disabled="validators.required(meta.groupnm)!==true" @click="addGroup"/>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <ConfirmCard v-if="meta.poptype=='save'||meta.poptype=='del'" :ttl="$t('man_ext_api')" :cont="$t(meta.poptype+'_con')" @cancel="pop" @confirm="mod"/>
    <Logs v-if="meta.poptype=='log'" ispop showtitle @close-log="pop"/>
  </Teleport>
</template>
<style>
.admextapi table{border: 1px solid #e0e0e0;}
.admextapi th{background-color: #eee !important;text-align: center !important; width: 180px;}
.admextapi .detail td > div{padding-top: 20px !important;}
</style>
